import { useLocation } from 'react-router-dom';
import BottomNav from './BottomNav';
import NotificationBell from './NotificationBell';
import { useAuth } from '../contexts/AuthContext';

export const Layout = ({ children }) => {
  const location = useLocation();
  const { token } = useAuth();
  
  // Pages où on cache la navigation
  const hideNav = ['/login', '/signup', '/admin', '/landing', '/payment'].some(path => location.pathname.startsWith(path));
  const isHomePage = location.pathname === '/';
  const hideNavOnHome = isHomePage && !token;
  
  const showNotifications = token && !hideNav && !hideNavOnHome;

  return (
    <div className="min-h-screen flex flex-col">
      {showNotifications && (
        <div className="fixed top-4 right-4 z-50">
          <NotificationBell />
        </div>
      )}
      <main className="flex-1 pb-24">
        {children}
      </main>
      {!hideNav && !hideNavOnHome && <BottomNav />}
    </div>
  );
};

export default Layout;
